export default __webpack_public_path__ + "static/media/spideyLogo.4b28539a.png";